import { LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE, ORDER_BY } from '@app/constants/Common';
import { showMessage } from '@app/constants/Messages';
import {
    DVTJCUVConnectCddEmpBriefSentTabs,
    DVTJCUVConnectCddEmpParentTabs, DVTJCUVConnectCddFUReceiverTabs,
    DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs
} from '@pages/dvtjcuv/common/ConnectCddEmpTabs';
import { DVTJCUVWorkWithRecParentTabs } from '@pages/dvtjcuv/common/WorkWithRecTabs';
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import HeaderSearchButtons from '@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons';
import RunDVTJCUVCandidateList from "@pages/dvtjcuv/rundvtjcuv/RunDVTJCUVCandidateList";
import ConnectCddEmpSendMailTabContent from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/ConnectCddEmpSendMailTabContent';
import InputCddGPEmpDiscussionModal from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';
import Button from "react-bootstrap/Button";
import ConnectCddEmpPaymentAndWarrantyTabContent from './ConnectCddEmpPaymentAndWarrantyTabContent';


const ConnectCddEmpContent = (props) => {
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    const [childTabList, setChildTabList] = useState([]);
    const [pipelineList, setPipelineList] = useState([]);
    const [dataInfo, setDataInfo] = useState({});
    const [mailTabData, setMailTabData] = useState({});
    const [loadingPipelines, setLoadingPipelines] = useState(true);
    const [showInputCddGPEmpDiscussion, setShowInputCddGPEmpDiscussion] = useState(false);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [sortColumns, setSortColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });

    const {data, parentTab} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showBtnSearchPipeline, setShowBtnSearchPipeline] = useState(false);
    const [showBtnSearchCdd, setShowBtnSearchCdd] = useState(false);
    const [showBtnSearchReceiver, setShowBtnSearchReceiver] = useState(false);
    const [showBtnSearchEmployer, setShowBtnSearchEmployer] = useState(false);


    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const fetchPipeLines = async (pTab, subTab, sorts, searchConds) => {
        if (!searchConds) {
            searchConds = {}
        }

        searchConds.parent_tab = pTab?.id
        searchConds.sub_tab = subTab?.id
        searchConds.unlimited = true

        const params = {
            search_conditions: searchConds,
            sort_columns: sorts || sortColumns
        }

        setLoadingPipelines(true)
        const res = await requestGetDVTJCUVPipeLineList(params);
        setLoadingPipelines(false)

        const resContent = res.content

        setPipelineList(resContent.pipelines)
    }

    const setTabContents = (pTab) => {
        console.log('setTabContents', pTab)
        let currTab = {}
        let childTabs = []
        if (pTab.id === DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id) {
            currTab = {...DVTJCUVConnectCddEmpBriefSentTabs.OFFERING_TAB}
            childTabs = Object.values(DVTJCUVConnectCddEmpBriefSentTabs)
            setShowBtnSearchCdd(true)
        }
        else if (pTab.id === DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id || pTab.id === DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id) {
            setShowBtnSearchCdd(true)
            setShowBtnSearchPipeline(true)
            setShowBtnSearchEmployer(true)
            setShowBtnSearchReceiver(true)
        }
        else if (pTab.id === DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id) {
            setShowBtnSearchCdd(true)
        }
        else if (pTab.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id) {
            currTab = {...DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.RECEIVER_LIST_TAB}
            childTabs = Object.values(DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs)
        }
        else if (pTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id) {
            currTab = {...DVTJCUVConnectCddFUReceiverTabs.RECEIVER_LIST_NEED_FU_TAB}
            childTabs = Object.values(DVTJCUVConnectCddFUReceiverTabs)
        }

        setParentOfTab(pTab)
        setCurrentTab(currTab)
        setChildTabList(childTabs)
        fetchPipeLines(pTab, currTab, sortColumns)
    }

    useEffect(() => {
        // alert(parentTab.id)
        if (parentTab) {
            setTabContents(parentTab)
        }
        if (data) {
            setDataInfo(data)
        }
    }, [data, parentTab]);

    const onTabClicked = async (tab) => {
        setCurrentTab({...tab});
        await fetchPipeLines(parentTab, tab)
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({...item})
        setShowUpdatePipelineModal(true)
    }

    const onInputGPEmpDiscussion = () => {
        setShowInputCddGPEmpDiscussion(true)
    }

    const onSort = async (columnKey) => {
        let newSorts = {...sortColumns}
        if (newSorts[columnKey] && newSorts[columnKey] === ODER_BY_TYPE.ASC) {
            newSorts[columnKey] = ODER_BY_TYPE.DESC
        } else {
            newSorts = {}
            newSorts[columnKey] = ODER_BY_TYPE.ASC
        }
        setSortColumns(newSorts)
        await fetchPipeLines(parentTab, currentTab, newSorts)
    }

    return (
        <>
            <div className="container-fluid">
                <div className="card card-default mt-3">
                    <div className="card-header">
                        <h3 className="card-title"><b>{parentOfTab.title}</b></h3>
                        <div className={"card-tools row"}>
                            {parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id &&
                            parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&
                                <HeaderSearchButtons
                                    parentTabId={parentTab.id}
                                    // no need to sub tab id => brief sent tab
                                    // tabId={currentTab.id}
                                    // showBtnSearchPipeline={parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id}
                                    // showBtnSearchCdd={parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id}
                                    showBtnSearchPipeline={showBtnSearchPipeline}
                                    showBtnSearchCdd={showBtnSearchCdd}
                                    showBtnSearchReceiver={showBtnSearchReceiver}
                                    showBtnSearchEmployer={showBtnSearchEmployer}
                                />
                            }

                            {/* {(parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                    || parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id) &&
                            <SearchCddConditionInput
                                notShowBtnSearchByRanges={parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id}
                                notShowBtnSearchByCandidates={parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id}
                                btnSearchByPipelineText={parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id ? 'Search' : ''}
                                parentTabId={parentOfTab.id}
                                tabId={currentTab.id}
                                mode={'search-receiver'}
                                onSearchResult={(pipelines) => {
                                    console.log('onSearchResult')
                                    setPipelineList([...pipelines])
                                }}/>
                            } */}
                            {parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                             && parentOfTab.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id &&
                            <Button variant='info' onClick={() => onInputGPEmpDiscussion()} className={'btn-sm ml-3'}>
                                Nhập Cdd-GP-Emp Discussion
                            </Button>
                            }
                            {/*{parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&*/}
                            {/*    <>*/}
                            {/*        <Button variant='primary' onClick={() => onInputGPEmpDiscussion()} className={'btn-sm ml-3'}>*/}
                            {/*            Search*/}
                            {/*        </Button>*/}
                            {/*    </>*/}
                            {/*}*/}
                        </div>
                    </div>

                    
                    <div className="card-body p-0">
                        {(
                            parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id
                            || parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                            || parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id) ?
                        <>
                            <ul className='nav nav-tabs' role='tablist'>
                                {childTabList.map(tab => (
                                    <li className='nav-item' key={`saved-list-tab-item-${tab.id}`}>
                                        <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                                           onClick={() => onTabClicked(tab)}>{tab.title} ({mailTabData[tab.id] ? mailTabData[tab.id] : 0})</a>
                                    </li>
                                ))}
                            </ul>
                            {!loadingPipelines &&
                            <div className='tab-content'>
                                {childTabList.map((tab, index) => {
                                    if (currentTab.id === tab.id) {
                                        if (parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                            || parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                                        ) {
                                            if (currentTab.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.SEND_EMAIL_TAB.id
                                                || currentTab.id === DVTJCUVConnectCddFUReceiverTabs.SEND_EMAIL_TAB.id
                                                || currentTab.id === DVTJCUVWorkWithRecParentTabs.SEND_EMAIL_INVITE_JOB_TAB.id
                                            ) {
                                                return <ConnectCddEmpSendMailTabContent
                                                    parentTab={currentTab}
                                                    onChangeParentTab={onTabClicked}/>
                                            }
                                            return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                        style={{height: '83vh', overflow: 'auto'}}
                                                        key={`run-job-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                                <RunDVTJCUVCandidateList runJob={dataInfo}
                                                                         inputCandidateIds={pipelineList.map(item => item.cdd_id)}
                                                                         requireFilterInputCandidateIs
                                                                         onChangeTab={onTabClicked}
                                                                         parentTab={parentOfTab}
                                                                         subTab={currentTab}/>
                                            </div>
                                        }
                                        return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                    style={{height: '83vh', overflow: 'auto'}}
                                                    key={`run-dvtjcuv-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                            <DVTJCUVPipelineTableList
                                                pipeLines={pipelineList}
                                                mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP}
                                                parentTabId={parentTab.id}
                                                onSort={onSort}
                                                sortColumn={sortColumns}
                                                subTabId={currentTab.id}
                                                onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                                            />
                                        </div>
                                    }
                                    return "";
                                    })
                                }
                            </div>
                            }
                        </>
                        :
                        <>
                            {parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.PRIORITY_PROCESS_TAB.id
                                &&
                                <div className={'card card-default'}>
                                    <div className='card-header'>
                                        <h3 className='card-title text-bold'>
                                            DVTJCUV pipelines
                                        </h3>
                                    </div>
                                    <div className='card-body'>
                                        <DVTJCUVPipelineTableList
                                            pipeLines={pipelineList}
                                            mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP}
                                            parentTabId={parentTab.id}
                                            subTabId={currentTab.id}
                                            onSort={onSort}
                                            sortColumn={sortColumns}
                                            onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                                        />
                                    </div>
                                </div>
                            }

                            {parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB.id &&
                                <ConnectCddEmpPaymentAndWarrantyTabContent/>
                            }

                            {parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id &&
                                <>
                                <RunDVTJCUVCandidateList
                                                    runJob={dataInfo}
                                                    parentTab={parentOfTab}
                                                    subTab={currentTab}/>
                                    {/* {childTabList.map((tab, index) => {
                                        if (currentTab.id === tab.id) {
                                            return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                        style={{height: '83vh', overflow: 'auto'}}
                                                        key={`run-job-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                                <RunDVTJCUVCandidateList
                                                    runJob={dataInfo}
                                                    parentTab={parentOfTab}
                                                    subTab={currentTab}/>
                                            </div>
                                        }
                                        return "";
                                    })} */}
                                </>
                            }
                            {parentOfTab.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id && !loadingPipelines &&
                                <>
                                    <div style={{height: '83vh', overflow: 'auto'}}
                                        key={`run-job-sub-tab-content-${parentTab.id}-${currentTab.id}`}>
                                        <RunDVTJCUVCandidateList runJob={dataInfo}
                                                                    inputCandidateIds={pipelineList.map(item => item.cdd_id)}
                                                                    requireFilterInputCandidateIs
                                                                    onChangeTab={onTabClicked}
                                                                    parentTab={parentOfTab}
                                                                    subTab={currentTab}/>
                                    </div>
                                </>
                            }
                        </>
                        }
                    </div>
                </div>
            </div>

            {showInputCddGPEmpDiscussion &&
            <InputCddGPEmpDiscussionModal
                onClose={(success) => {
                    if (success) {
                        showMessage("Đã lưu Cdd-GP-Emp Discussion thành công.", false, true);
                    }
                    setShowInputCddGPEmpDiscussion(false);
                }}
                isShow={showInputCddGPEmpDiscussion} />
            }

            {showUpdatePipelineModal &&
            <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                                        pipeLineInfo={selectPipeline}
                                        onClose={(reload) => setShowUpdatePipelineModal(false)}
            />
            }
        </>
    )
}

export default ConnectCddEmpContent;
